/* THEBLACKBOXHUB — search.js
   Predictive search (Shopify Predictive Search API + Section Rendering).
   The surrounding <form action="/search"> works without JavaScript. */
(function () {
  'use strict';

  const theme = window.theme || { routes: {}, strings: {} };

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      if (!this.input || !this.results || !theme.routes.predictiveSearch) return;
      this.cache = {};
      this.selectedIndex = -1;
      let timer;
      this.input.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.onInput(), 250);
      });
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.input.setAttribute('aria-expanded', 'false');
    }

    get query() {
      return this.input.value.trim();
    }

    onInput() {
      const q = this.query;
      if (!q) {
        this.close();
        return;
      }
      if (this.cache[q]) {
        this.render(this.cache[q]);
        return;
      }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      this.setStatus(theme.strings.loading || 'Loading…');
      const url =
        theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,query,page' +
        '&resources[limit]=4&resources[limit_scope]=each';
      fetch(url, this.controller ? { signal: this.controller.signal } : {})
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const section = doc.querySelector('#shopify-section-predictive-search');
          const html = section ? section.innerHTML : '';
          this.cache[q] = html;
          if (this.query === q) this.render(html);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          this.setStatus(theme.strings.network || 'Something went wrong. Please try again.');
        });
    }

    render(html) {
      this.results.innerHTML = html;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
      this.selectedIndex = -1;
      this.setStatus('');
      const live = this.results.querySelector('[data-predictive-count]');
      if (live && this.status) this.status.textContent = live.textContent;
    }

    close() {
      this.results.hidden = true;
      this.results.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.setStatus('');
    }

    setStatus(text) {
      if (this.status) this.status.textContent = text;
    }

    onKeydown(event) {
      const items = Array.from(this.results.querySelectorAll('[role="option"]'));
      if (!items.length || this.results.hidden) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const dir = event.key === 'ArrowDown' ? 1 : -1;
        this.selectedIndex = (this.selectedIndex + dir + items.length) % items.length;
        items.forEach((item, i) => item.setAttribute('aria-selected', i === this.selectedIndex ? 'true' : 'false'));
        const active = items[this.selectedIndex];
        this.input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && this.selectedIndex > -1) {
        const active = items[this.selectedIndex];
        const link = active.tagName === 'A' ? active : active.querySelector('a');
        if (link) {
          event.preventDefault();
          window.location.href = link.href;
        }
      }
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();
